class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      // Mihai edit: rewrite the query Shopify actually searches against so it
      // only matches the product title or description, instead of Shopify's
      // default broader match (tags, vendor, type, etc). See onSearchFormSubmit.
      this.input.form.addEventListener('submit', this.onSearchFormSubmit.bind(this));

      // If we landed here via a rewritten (title/body-scoped) query, show the
      // plain term the shopper actually typed in the search box instead of
      // the internal search syntax.
      const displayTerm = new URLSearchParams(window.location.search).get('display_term');
      if (displayTerm !== null) {
        this.input.value = displayTerm;
      }
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }

  // Builds a Shopify search-syntax query that only matches the product title
  // or description (body), e.g. "monaco" -> "(title:monaco) OR (body:monaco)".
  // Multi-word terms become an AND of each word within each field:
  // "bratara aur" -> "(title:bratara title:aur) OR (body:bratara body:aur)".
  buildScopedSearchQuery(term) {
    const words = term.trim().split(/\s+/).filter(Boolean);
    if (!words.length) return term;
    const escapeWord = (word) => word.replace(/[:\\()]/g, '\\$&');
    const titlePart = words.map((word) => `title:${escapeWord(word)}`).join(' ');
    const bodyPart = words.map((word) => `body:${escapeWord(word)}`).join(' ');
    return `(${titlePart}) OR (${bodyPart})`;
  }

  onSearchFormSubmit(event) {
    if (!this.input || !this.input.value.trim().length) return;

    // Leave advanced queries the shopper typed themselves untouched.
    if (/[:"()]/.test(this.input.value)) return;

    event.preventDefault();

    const rawTerm = this.input.value.trim();
    const scopedQuery = this.buildScopedSearchQuery(rawTerm);

    const params = new URLSearchParams(new FormData(this.input.form));
    params.set('q', scopedQuery);
    params.set('display_term', rawTerm);

    window.location.href = `${this.input.form.getAttribute('action')}?${params.toString()}`;
  }
}

customElements.define('search-form', SearchForm);
